<template lang="pug">
  div
    p Are you currently homeless?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.housing' value='address')
        i.form-icon
        | No
      label.form-radio
        input(type='radio' v-model='intakeConfig.housing' value='homeless')
        i.form-icon
        | Yes

    p Do you currently have a case worker?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.referral' value='null-caseworker')
        i.form-icon
        | No
      label.form-radio
        input(type='radio' v-model='intakeConfig.referral' value='referral')
        i.form-icon
        | Yes

    p What do you most strongly identify as?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.sex' value='male')
        i.form-icon
        | Male
      label.form-radio
        input(type='radio' v-model='intakeConfig.sex' value='female')
        i.form-icon
        | Female
      label.form-radio
        input(type='radio' v-model='intakeConfig.sex' value='sex-other')
        i.form-icon
        | Other

    p Are you a legal guardian?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.family' value='null-family')
        i.form-icon
        | No
      label.form-radio
        input(type='radio' v-model='intakeConfig.family' value='family')
        i.form-icon
        | Yes

    p Do you currently receive SSI, SSDI or VA Pension?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.ssi' value='null-ssi')
        i.form-icon
        | No
      label.form-radio
        input(type='radio' v-model='intakeConfig.ssi' value='ssi')
        i.form-icon
        | Yes

    p Are you disabled?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.disabled' value='null-disabled')
        i.form-icon
        | No
      label.form-radio
        input(type='radio' v-model='intakeConfig.disabled' value='disabled')
        i.form-icon
        | Yes

    p Do you have mental health concerns?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.mental-health' value='null-mental-health')
        i.form-icon
        | No
      label.form-radio
        input(type='radio' v-model='intakeConfig.mental-health' value='mental-health')
        i.form-icon
        | Yes

    p Are you a minority?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.minority' value='null-minority')
        i.form-icon
        | No
      label.form-radio
        input(type='radio' v-model='intakeConfig.minority' value='minority')
        i.form-icon
        | Yes

    p Are you a veteran?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.veteran' value='null-veteran')
        i.form-icon
        | No
      label.form-radio
        input(type='radio' v-model='intakeConfig.veteran' value='veteran')
        i.form-icon
        | Yes

    p Are you a senior?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.senior' value='null-senior')
        i.form-icon
        | No
      label.form-radio
        input(type='radio' v-model='intakeConfig.senior' value='senior')
        i.form-icon
        | Yes

    p Are you under 21?
    .form-group
      label.form-radio
        input(type='radio' v-model='intakeConfig.youth' value='null-youth')
        i.form-icon
        | No
      label.form-radio
        input(type='radio' v-model='intakeConfig.youth' value='youth')
        i.form-icon
        | Yes
</template>





<script>
  import {mapState} from 'vuex'

  export default {
    name: 'intake-form',

    computed: mapState([
      'intakeConfig'
    ])
  }
</script>



// WEBPACK FOOTER //
// src/components/checklist/Intake.vue